import styled, { css } from "styled-components";

import { largeScreen } from "src/shared/constants/screenSizes";
import CB from "src/shared/contact-boxes/components/ContactBox";
import { ContactBoxContents } from "src/shared/contact-boxes/components/ContactBox/styled";
import ContactBoxHeader from "src/shared/contact-boxes/components/ContactBoxHeader";

import { Button } from "../ContactForm/styled";

export const ContactBox = styled(CB)`
  ${({ $hasDrawerForm }) =>
    $hasDrawerForm &&
    css`
      border: none;
      flex: 1 0 auto;
      overflow: auto;

      @media (min-width: ${largeScreen}px) {
        height: 100px;
        padding: 48px 60px 60px;
      }

      ${({ isModal }) => isModal && `padding-bottom: 75px;`}

      ${Button} {
        display: none;
      }

      && > ${ContactBoxHeader} {
        display: flex;

        @media (min-width: ${largeScreen}px) {
          display: block;
          padding: 0 0 12px;
          font-size: 32px;
          font-weight: 300;
          text-transform: none;
          line-height: 40px;
        }
      }

      && > ${ContactBoxContents} {
        height: 100%;

        @media (min-width: ${largeScreen}px) {
          margin: auto;
          padding: 20px 0 20px;
        }
      }
    `}
`;
